import React from 'react';
import ReactDOM from 'react-dom/client';
import 'index.css';
import App from 'App';

const newRelicScript = document.createElement('script');
newRelicScript.src = `/scripts/newrelic.js`;
newRelicScript.async = true;
document.head?.appendChild(newRelicScript);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);
